#import "@/components/common/ArticlePreviewFragment.gql"

fragment ArticleRowSlideFragment on articleRowSlide_Entry {
  id
  typeHandle
  heading
  backgroundGray
  articles {
    ...ArticlePreviewFragment
  }
}
